import { FormatNumberOptions, FormattedNumber } from 'react-intl';
import { config } from '../../../utils/config';

export const getCurrencyConfig = (differentCurrency?: string): FormatNumberOptions => ({
  style: 'currency',
  currency: differentCurrency ?? config.currency,
  currencyDisplay: config.formats.currency,
  minimumFractionDigits: config.formats.hideCurrencyDecimals ? 0 : undefined,
  maximumFractionDigits: config.formats.hideCurrencyDecimals ? 0 : undefined
});

const FormattedCurrency = ({ value, differentCurrency }: { value: number; differentCurrency?: string }) => (
  <FormattedNumber value={value / 100} {...getCurrencyConfig(differentCurrency)} />
);

export default FormattedCurrency;
